function AusverkauftBanner({ text }) {
    if (!text) return null;

    return (
        <div
            className="relative z-[60] w-full bg-golden text-blue-dark text-center font-bold py-2.5 px-4 text-sm md:text-base shadow-md"
            role="status"
        >
            {text}
        </div>
    );
}

export default AusverkauftBanner;
